import AskAiSidebar from "@apps/ask-ai/components/ask-ai-sidebar";
import { currentOrganizationVar } from "@cache/cache";
import Layout from "@components/layout/layout";

import ProfileSidebarDetails from "./profile-sidebar-details";

const ProfilePageSidebar = ({ profileId }: { profileId: number }) => {
  const organization = currentOrganizationVar();
  const askAIEnabled = !!organization.featureFlags.askAi;

  // Orgs without Ask AI keep the employee details in the sidebar; everyone can
  // still open them from the "View employee details" action in the "…" menu.
  if (!askAIEnabled) {
    return (
      <Layout.Sidebar sidebarExpandedUiPreferenceKey="profileSidebarExpanded">
        <ProfileSidebarDetails profileId={profileId} />
      </Layout.Sidebar>
    );
  }

  // Same shell as the meeting sidebar, with no meeting-scoped sections — the
  // plain "empty" Ask AI sidebar. The profile header can wrap onto a second row
  // on mobile, so sit the sidebar lower there.
  return (
    <AskAiSidebar
      sidebarExpandedUiPreferenceKey="profileSidebarExpanded"
      resetKey={profileId}
      askAIEnabled={askAIEnabled}
      ariaLabel="Profile Ask AI sidebar"
      topClassName="top-28 md:top-14"
    />
  );
};

export default ProfilePageSidebar;
